{
  "title": "Instructions de paiement",
  "body": "Configurez le montant, la fréquence et la destination de vos retraits de FERR en fonction de vos besoins financiers.",
  "paymentFrequency": "Fréquence de paiement:",
  "startDate": "Date de début:",
  "depositTo": "Dépôt sur:",
  "modal": {
    "title": "Définir les instructions de paiement",
    "subtitle": {
      "1": "Un FERR fournit un revenu de retraite régulier, permettant des retraits flexibles et progressifs selon la fréquence et le montant de votre choix, à condition qu'ils respectent les critères suivants ",
      "2": "Retrait annuel minimum ",
      "3": "montant."
    },
    "ageSelectLabel": "Choisir l'âge pour le calcul du retrait minimum",
    "myAgeSelectOption": "Utiliser mon âge ({{age}})",
    "mySpousesAgeSelectOption": "Utiliser l'âge du conjoint ({{âge}})",
    "totalAnnualWithdrawalLabel": "Retrait annuel total",
    "totalAnnualWithdrawalMinimumAmountOption": "Montant minimum autorisé",
    "totalAnnualWithdrawalCustomAmountOption": "Montant personnalisé",
    "totalAnnualWithdrawalMaximumAmountOption": "Montant maximum autorisé",
    "amountLabel": "Montant",
    "paymentFrequencyLabel": "Fréquence des paiements",
    "ANNUALLY": "Annuel",
    "SEMI_ANNUALLY": "Semestriellement",
    "QUARTERLY": "Trimestriel",
    "MONTHLY": "Mensuel",
    "withdrawalTypeLabel": "Type de retrait",
    "withdrawalTypeNetOption": "Net",
    "withdrawalTypeGrossOption": "Brut",
    "startDateLabel": "Date de début",
    "note1": "Les instructions de paiement seront exécutées comme indiqué. Vous pouvez toujours modifier vos préférences de paiement. Il faut noter que tous les retraits sont entièrement imposables comme gain pendant l'année où il est retiré, et que les montants supérieurs au paiement minimum annuel encourront également des retenues d'impôt.",
    "note2": "* Le retrait minimum pour l'année est une estimation basée sur l'âge sélectionné et est susceptible de changer.",
    "subAccountLabel": "Sous-compte"
  },
  "lifTitle": "fonds de revenu viager",
  "rifTitle": "fonds de revenu de retraite",
  "totalAnnualWithdrawal": "Retrait annuel total :",
  "amount": "Montant :",
  "invalidSubAccountToastMessage": "Nécessite un sous-compte valide à l'état ACTIVE ou AWAITING_REVIEW"
}
